export default "__VITE_ASSET__D00WQI$Q__"